import { React, Component } from 'react'
import Steps from '../../../components/Steps/Steps';
import { Redirect } from 'react-router-dom';
import PaymentPix from '../../../components/PaymentPix/PaymentPix';
import SelectedPlan from '../../../components/SelectedPlan/SelectedPlan';


class Pix extends Component {
    constructor(props){
        super(props);

        this.state = {
            step: 3,
            tooltipText: 'Clique para copiar'
        }

        this.copyToClipboard = this.copyToClipboard.bind(this);
    }

    copyToClipboard(e){

        var input = document.getElementById("qrcode");
        input.focus();
        input.select();
        document.execCommand('copy');
        
        this.setState({
            tooltipText: 'Copiado!'
        })

    }

    render() {

        if(!localStorage.getItem("token")){
            return (
                <Redirect to="/" />
            )
        }

        return(
            <div className="page-container page">

                <SelectedPlan />

                <div className="position-relative">
                    <div className="p-5">

                        <PaymentPix />
                        
                    </div>
                </div>
            </div>
        )

    }
}

export default Pix;